import { render, staticRenderFns } from "./ArchiveBtn.vue?vue&type=template&id=40061d5d&"
import script from "./ArchiveBtn.vue?vue&type=script&lang=js&"
export * from "./ArchiveBtn.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports